export default "__VITE_ASSET__01GpGh5o__"